// 引入工具函数
import req from '@/utils/request';

// 支付
export const pay = (params) => {
    return req.post('/pay/pay', params);
}

//预支付
export const prePay = (params) => {
    return req.post('/pay/prePay', params);
}

// 查询支付信息
export const getPayRecord = (params) => {
    return req.get('/pay/getPayRecord', params);
}

//预退款
export function preRefund(params) {
    return req.post('/pay/preRefund', params)
}

//退款
export function refund(params) {
    return req.post('/pay/refund', params)
}

// 查询支付退款记录
export const getOrderRecord = (params) => {
        return req.get('/pay/getOrderRecord', params);
    }
    // 查询退款记录
export const getRefundRecord = (params) => {
        return req.get('/pay/getRefundRecord', params);
    }
    // 查询查询收费详情
export const getPayDetail = (params) => {
    return req.get('/pay/payRecord', params);
}
// 查询收费单据中订单发票列表
export const getInvoiceList = (params) => {
    return req.get('/invoice/charge/info', params);
}

// 查询退款项目
export const getRefundItemOld = (params) => {
    return req.get('/refund/task/getRefundItem', params);
}
export const getRefundItem = (params) => {
    return req.get('/refund/task/getRefundItemByRefundDrug', params);
}


// 创建退款单
export const createRefundTask = (params) => {
    return req.post('/refund/task/createRefundTask', params);
}

// 创建退款单（自动退药）
export const createRefundTaskBatch = (params) => {
    return req.post('/refund/task/createRefundTaskBatch', params);
}

// 编辑退款单
export const editRefundTaskDetail = (params) => {
    return req.post('/refund/task/editRefundTaskDetail', params);
}

// 查询退款单列表
export const queryRefundTaskList = (params) => {
    return req.get('/refund/task/queryRefundTaskList', params);
}

// 查询退款单列表
export const getRefundTask = (params) => {
    return req.get('/refund/task/getRefundTask', params);
}

// 退款重试
export const refundRetry = (params) => {
    return req.post('/pay/refundRetry', params);
}

// 更换退款方式
export const changeTaskDetail = (params) => {
    return req.post('/refund/task/changeTaskDetail', params);
}

// 查询预支付记录信息
export const prePayRecords = (params) => {
        return req.get('/pay/prePayRecords', params);
    }
    // 支付完成
export const payCallback = (params) => {
    return req.post('/pay/payCallback', params);
}
// 获取支付中的支付单号
export const getOrderPayNum = (params) => {
    return req.post('/pay/listPayRecord', params);
}
// 取消支付中状态
export const cancelPayingStatus = (params) => {
    return req.post('/pay/callback', params);
}

// 退款完成
export const refundCallback = (params) => {
    return req.post('/pay/refundCallback', params);
}